<template>
    <div class="mt-4">
        <b-row>
            <b-col col lg="12" md="12" sm="12">
                <b-tabs>
                    <b-tab v-for="(tab, index) in tabs" :key="index">
                        <template slot="title">
                            <span class=""> {{tab.text}}</span>
                        </template>
                        <keep-alive>
                            <component :patient="patient" v-bind:is="tab.key"></component>
                        </keep-alive>
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import PersonalInfoTab from './InformationTab/PersonalInfoTab';
  import OtherInfoTab from './InformationTab/OtherInfoTab';
  import InsuranceTab from './InformationTab/InsuranceTab';
  import AppointmentTab from './InformationTab/AppointmentTab';
  import ContactTab from './InformationTab/ContactTab';
  import PrescriptionList from '@/views/Prescription/PrescriptionList';

  export default {
    props: {
      patient: {
        type: Object
      }
    },
    data() {
      return {
        tabs: [
          {key: 'personal-info-tab', text: 'Personal Info', active: true},
          {key: 'other-info-tab', text: 'Other Info'},
          {key: 'insurance-tab', text: 'Insurance'},
          {key: 'contact-tab', text: 'Contacts'},
          {key: 'appointment-tab', text: 'Appointments'},
          {key: 'prescription-list', text: 'Prescriptions'}
        ]
      }
    },

    components: {
      PersonalInfoTab,
      AppointmentTab,
      OtherInfoTab,
      InsuranceTab,
      ContactTab,
      PrescriptionList
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Patient/Detail/PatientInformation.vue